export default __webpack_public_path__ + "static/media/leaderboard_button.69006771.svg";